<template>
  <div class="HorizontalMenu">
    <div class="menuWrapping">
      <el-menu
        ref="elMenu"
        :default-active="activeIndex"
        router
        class="el-menu-demo"
        mode="horizontal"
        :style="`transform:translate(0,${-left}px)`"
      >
        <el-menu-item
          v-for="item in levelRoute"
          :key="item.path"
          :index="item.path"
        >
          <svgIcon
            class="svgIcon"
            :icon-class="item.meta&&item.meta.icon"
          />
          {{ generateTitle(item.meta&&item.meta.title) }}
        </el-menu-item>
      </el-menu>
    </div>
    <div
      v-if="upDownBtnVisi"
      class="updownBtn"
    >
      <div
        class="up"
        @click="menuMove(1)"
      ></div>
      <div
        class="down"
        @click="menuMove(2)"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import { generateTitle } from '@/utils/i18n'
export default {
  components: {
  },
  data() {
    return {
      loading: false,
      left: 0,
      upDownBtnVisi: false
    }
  },
  computed: {
    ...mapState({
      levelRoute: state => {
        return state.permission.routes.filter(item => !item.hidden)
      }
    }),
    activeIndex: function () {
      const route = this.$route
      let path = route.fullPath.split('/')[1]
      if (path === 'dashboard') {
        path = ''
      }
      return '/' + path
    }
  },
  mounted() {
    this.resizeEvent()
  },
  created() {
    this.resizeEventDebounce = _.debounce(this.resizeEvent, 100)
    window.addEventListener('resize', this.resizeEventDebounce)
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeEventDebounce)
  },
  methods: {
    generateTitle,
    menuMove(type) {
      const height = this.$refs.elMenu.$el.clientHeight
      if (type === 1) {
        if (this.left > 0) {
          this.left -= 60
        }
      } else {
        if (this.left < height - 60) {
          this.left += 60
        }
      }
    },
    resizeEvent() {
      const height = this.$refs.elMenu.$el.clientHeight
      this.upDownBtnVisi = height > 60
      this.left = 0
    }

  }
}
</script>

<style lang="scss" scoped>

.el-menu-demo{
    transition: all .4s;
}

.HorizontalMenu {
    flex: 1;
    position: relative;
    .menuWrapping{
        margin-right: 10px;
        padding-right: 20px;
        height: 60px;
    }
    .svgIcon{
      vertical-align: -0.1em;
    }
    .updownBtn{
        position: absolute;
        right: 20px;
        top: 0;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        >div{
            width: 0;
            height: 0;
            border-radius: 2px;
            cursor: pointer;
        }
        .up{
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-bottom: 8px solid #000;
        }
        .down{
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top: 8px solid #000;
            margin-top: 2px;
        }
    }
  }
</style>
